import React from 'react';

export const month = ['January','February','March','April','May','June','July','August','September','October','November','December'];
export const clubs = ['Other', 'Usna', 'The Robe', 'Castlebar','Knock Summer','Knock','Swinford','Breaffy Hotel','Abbeyknockmoy','Balla','Ballina','Castlerea','Kiltimagh','Kilcolman','Headford','Carrick-on-Shannon','Claremorris','Tuam', 'Ballinrobe', 'Ballygar','Westport','Region','Plaza Hotel'];
export const activation_status = ['activated', 'deactivated'];
export const registration_status = ['opened', 'closed'];

export const year_select = () => {
    const currentYear = new Date().getFullYear();
    const futureYears = 10;
    let allYears = [];

    // Generate years from current year to 10 years ahead
    for (let year = currentYear; year <= currentYear + futureYears; year++) {
        allYears.push(year);
    }
    return allYears;
  }
  
  export const day_select =() =>{
    let maxOffset = 30;
    let days = 31;
    let allDays = [];
    for(let x = 0; x <= maxOffset; x++) {
      allDays.push(days - x)
    }
    return allDays;
  }
  
  
  export const  hour_select =() =>{
    let maxOffset = 12;
    let thisYear = 23;
    let hours = [];
    for(let x = 0; x <= maxOffset; x++) {
        hours.push(thisYear - x)
    }
    return hours;
  }
  
  export const  min_select= () =>{
    let maxOffset = 3;
    let thisYear = 60;
    let hours = [];
    let interval = 15;
    for(let x = 0; x <= maxOffset; x++) {
        hours.push(thisYear - interval)
        interval+=15;
    }
    return hours;
  }

  export const renderInput = ({ input, label, meta }) => {
    const className = `required field ${meta.error && meta.touched ? 'error' : ''}`
    return (
      <div className={className}>
        <label>{label}</label>
        <input {...input} autoComplete="off" placeholder={label}/>
        {renderError(meta)}
      </div>
    );
  }

  export const renderNumberInput = ({ input, label, meta }) => {
    const className = `required field ${meta.error && meta.touched ? 'error' : ''}`
    return (
      <div className={className}>
        <label>{label}</label>
        <input {...input} autoComplete="off" placeholder={label} type="number"/>
        {renderError(meta)}
      </div>
    );
  }

  export const renderTextArea = ({ input, label, meta }) => {
    const className = `required field ${meta.error && meta.touched ? 'error' : ''}`
    return (
      <div className={className}>
        <label>{label}</label>
        <textarea {...input} autoComplete="off" placeholder={label} rows={1}/>
        {renderError(meta)}
      </div>
    );
  }

  export const renderSelect = ({ field, input, label, meta }) => {
     const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
    return (
      <div className={className}>
        <label>{label}</label>
        <select {...input} placeholder="Sort Data">
          <option value="">Select month</option>
          {month.map((x, index) => <option key={index} value={x}>{x}</option>)}
        </select>
        {renderError(meta)}
      </div>
    );
  }

  export const renderClubSelect = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
   return (
     <div className={className}>
       <label>{label}</label>
       <select {...input} placeholder="Sort Data">
         <option value="">Select club</option>
         {clubs.map((x, index) => <option key={index} value={x}>{x}</option>)}
       </select>
       {renderError(meta)}
     </div>
   );
 }

 export const renderEventActivation = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
  return (
    <div className={className}>
      <label>{label}</label>
      <select {...input} placeholder="Activation Status">
        <option value="">Select to activate/deactivate game</option>
        {activation_status.map((x, index) => <option key={index} value={x}>{x}</option>)}
      </select>
      {renderError(meta)}
    </div>
  );
  }

  export const renderEventRegistration = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
  return (
    <div className={className}>
      <label>{label}</label>
      <select {...input} placeholder="Activation Status">
        <option value="">Select to enable registration for this game</option>
        {registration_status.map((x, index) => <option key={index} value={x}>{x}</option>)}
      </select>
      {renderError(meta)}
    </div>
  );
  }

  export const renderSelectYear = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
   return (
     <div className={className}>
       <label>{label}</label>
       <select {...input} placeholder="Sort Data">
         <option value="">Select year</option>
         {year_select().map((x, index) => <option key={index} value={x}>{x}</option>)}
       </select>
       {renderError(meta)}
     </div>
   );
 }

 export const renderSelectHour = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
  return (
    <div className={className}>
      <label>{label}</label>
      <select {...input} placeholder="Sort Data">
        <option value="">Hour</option>
        {hour_select().map((x, index) => <option key={index} value={x}>{x}</option>)}
      </select>
      {renderError(meta)}
    </div>
  );
  }

  export const renderSelectMin = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
  return (
    <div className={className}>
      <label>{label}</label>
      <select {...input} placeholder="Sort Data">
        <option value="">Minutes</option>
        {min_select().map((x, index) => <option key={index} value={x}>{x}</option>)}
      </select>
      {renderError(meta)}
    </div>
  );
  }

  export const renderSelectDay = ({ field, input, label, meta }) => {
    const className = `selection required field ${meta.error && meta.touched ? 'error' : ''}`
  return (
    <div className={className}>
      <label>{label}</label>
      <select {...input} placeholder="Sort Data">
        <option value="">Select day of month</option>
        {day_select().map((x, index) => <option key={index} value={x}>{x}</option>)}
      </select>
      {renderError(meta)}
    </div>
  );
  }

 export const renderError=({error, touched}) =>{
      if(touched && error){
        return (
          <div className="ui error message">
            <div className="header">{error}</div>
          </div>
        );
      }
  }